import React from 'react';
import Youtube from 'react-player/youtube';
import Vimeo from 'react-player/vimeo';

interface VideoProps {
  key: string,
  videoId: string,
  width: number,
  height: number,
  serviceName: string,
}

const Video = ({
  key, videoId, width, height, serviceName,
}: VideoProps) => {
  let url = '';
  if (serviceName === 'vimeo') {
    url = `https://vimeo.com/${videoId}`;
    return <Vimeo
      {...{
        key, width, height, url,
      }}
      controls={true}
    />;
  }
  if (serviceName === 'youtube') {
    url = `https://www.youtube.com/watch?v=${videoId}`;
    return <Youtube
      {...{
        key, width, height, url,
      }}
      controls={true}
    />;
  }
  return null;
};

export default Video;
